import BenefitManagementStore from "stores/BenefitsManagementStore";
import {Formik} from "formik";

import "./BenefitsCreateForm.scss";

import React, {useState} from "react";
import {BenefitPayload} from "models/Benefit";
import DataForm from "../BenefitForm/BenefitForm";
import {useHistory} from "react-router-dom";
import Loader from "../../commons/Loader/Loader";
import Button from "components/commons/Button/Button";
import AppStore from "stores/AppStore";


const BenefitCreateForm: React.FC = () => {
  const history = useHistory();
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const { i18n: { benefits: { save } } } = AppStore;

  if (isUploading) {
    return <Loader />
  }


  const handleSubmit = (values: BenefitPayload) => {
    setIsUploading(true)
    BenefitManagementStore.addBenefit({ ...values, price: { value: Math.round(values.price.value * 100) } }).
    then(() => history.push("/benefits")).
    catch(() =>setIsUploading(false))
  }

  return (
    <div className="c-benefit-form">
      <Formik
        initialValues={{ "price": {"value": 0}, "id": "", "family": "", "isActive": false, "baseBenefit": false, "packageName": "" }}
        onSubmit={handleSubmit}
      >
        {({ submitForm, isValid }) => (
          <DataForm>
            <div className="c-benefit-form__actions">
              <Button className="c-benefit-form__action-button" text={save} onClick={submitForm} disabled={!isValid} />
            </div>
          </DataForm>
        )}
      </Formik>
    </div>
  )
}


export default BenefitCreateForm;